import axios from "axios";
import { useTaskDeviceBridge } from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import { isWebView } from "../components/utils/deviceUtils";
import {
  clearAuthTokens,
  getMbServerToken,
  setCookie,
  getRedirectToken,
} from "./cookieUtils";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => {
    if (axiosInstance.__is_native) {
      axiosInstance.__has_native_token = true;
    }
    return response;
  },
  async (error) => {
    const config = error.config;
    if (!config.__retryCount) {
      config.__retryCount = 0;
    }
    const shouldRetry =
      error.response?.status >= 400 &&
      config.__retryCount < 3 &&
      !axiosInstance.__has_native_token;

    const unAuthorized = error.response?.status === 401;
    if (axiosInstance.__has_native_token) {
      config.headers.authtoken = getMbServerToken();
      config.headers.accesstoken = getRedirectToken();
      await new Promise((resolve) => setTimeout(resolve, 200));
    }
    if (shouldRetry) {
      config.__retryCount += 1;
      if (isWebView()) {
        try {
          const taskDeviceBridge = useTaskDeviceBridge();
          if (taskDeviceBridge?.fetchNewToken) {
            const tokenData =
              await taskDeviceBridge.fetchNewToken("mbServerToken");
            if (tokenData && tokenData.mbServerToken && tokenData.redirect) {
              setCookie("mbServerToken", tokenData.mbServerToken);
              setCookie("redirect", tokenData.redirect);

              config.headers.authtoken = tokenData.mbServerToken.trim();
              config.headers.accesstoken = tokenData.redirect.trim();

              await new Promise((resolve) => setTimeout(resolve, 200));
              axiosInstance.__is_native = true;
              return axiosInstance(config);
            }
          }
        } catch (error) {
          console.error(error);
        }
        if (unAuthorized) {
          handleWebViewLogout();
        }
      } else {
        if (unAuthorized) {
          handleWebLogout();
        }
      }
    }
    return Promise.reject(error);
  },
);

function handleWebLogout() {
  clearAuthTokens();
  localStorage.clear();
  sessionStorage.clear();

  const currentUrl = window.location.href;
  const encodedReturnUrl = encodeURIComponent(currentUrl);

  const loginUrl = `/reimbursements/signin?returnUrl=${encodedReturnUrl}&message=session_expired`;
  window.location.href = loginUrl;
}

function handleWebViewLogout() {
  clearAuthTokens();
  localStorage.clear();
  sessionStorage.clear();

  try {
    if (window.WebToNativeCommunicationInterface) {
      window.WebToNativeCommunicationInterface.logout();
    } else {
      const currentUrl = window.location.href;
      const encodedReturnUrl = encodeURIComponent(currentUrl);
      const loginUrl = `/reimbursements/signin?returnUrl=${encodedReturnUrl}&message=session_expired`;
      window.location.href = loginUrl;
    }
  } catch (error) {
    console.error(error);
    handleWebLogout();
  }
}

export default axiosInstance;
